var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikedMutualGrid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "41px",
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikedMutualGrid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.9%",
    y: "-12.9%",
    width: "125.7%",
    height: "125.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.204285553 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.85740559,13.8 C11.0936382,13.8 12.3344105,14.3049718 13.2733921,15.313542 L13.2733921,15.313542 L14.3995966,16.5269302 L15.5258211,15.3199283 C17.4037645,13.3027449 20.473619,13.3027898 22.3515425,15.3199283 C24.2294858,17.3370688 24.2294858,20.5767262 22.3515425,22.5938688 C19.7959092,25.3389564 17.2414303,28.0871093 14.6858169,30.8321356 C14.6105939,30.9137561 14.5059551,30.96 14.3964905,30.96 C14.2870259,30.96 14.1823872,30.9137561 14.1071642,30.8321356 L14.1071642,30.8321356 L6.44765121,22.5874723 C4.57185828,20.5687685 4.56970789,17.3306499 6.44765121,15.313542 C7.38661295,14.3049697 8.62117301,13.8 9.85740559,13.8 Z M22.394886,7.04 C22.9786625,7.04 23.5645827,7.26953263 24.0079907,7.72797366 L24.0079907,7.72797366 L24.5398095,8.27951372 L25.0716377,7.7308765 C25.9584443,6.81397494 27.4080979,6.81399537 28.2948951,7.7308765 C29.1817016,8.64775855 29.1817016,10.1203301 28.2948951,11.0372131 L28.2948951,11.0372131 L24.6749691,14.7818798 C24.6394471,14.8189801 24.5900344,14.84 24.5383427,14.84 C24.4866511,14.84 24.4372384,14.8189801 24.4017164,14.7818798 L24.4017164,14.7818798 L20.7847242,11.0343056 C19.8989331,10.1167129 19.8979176,8.64484085 20.7847242,7.72797366 C21.2281228,7.2695317 21.8111095,7.04 22.394886,7.04 Z",
    id: "path-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLikedMutualGrid",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#91E359",
    xlinkHref: "#path-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikedMutualGrid);
export default __webpack_public_path__ + "static/media/icLikedMutualGrid.4bfa7759d0ad9c272a397dcf8ff9e200.svg";
export { ForwardRef as ReactComponent };